var _path, _path2, _path3, _circle, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyMessage = function SvgEmptyMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 125,
    viewBox: "0 0 118 125",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 5L4.5 43.5L48 82L50.5 80H53.5L56 82.5L100 44L52 5Z",
    fill: "#DFEDF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 123V45.5L47.5 84L52 81L57 84L102 44V123H2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 43.4742V123M2 43.4742L52 3L102 43.4742M2 43.4742L47.8333 84.134M2 123H102M2 123L47.8333 84.134M102 123V43.4742M102 123L56.1667 84.134M102 43.4742L56.1667 84.134M56.1667 84.134L52.5952 81.1443H52H51.4048L47.8333 84.134",
    stroke: "#0C2945",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 42.4966,
    r: 11.02,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 28C95.496 28 89 34.496 89 42.5C89 50.504 95.496 57 103.5 57C111.504 57 118 50.504 118 42.5C118 34.496 111.504 28 103.5 28ZM104.95 49.75H102.05V46.85H104.95V49.75ZM104.95 43.95H102.05V35.25H104.95V43.95Z",
    fill: "#00AEEF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-message.cfe14b66.svg";
export { ForwardRef as ReactComponent };